import React, { useState } from "react";
import VerificationPopUp from "../../VerificationPop/VerificationPopUp";
import Popup from "../../../components/popup/Popup";
import {
  AdminDetailFieldLabel,
  AdminHeaderAction,
  adminWizardInputClasses,
} from "../../AdminDashboard/shared/adminUx";
import {
  CUSTOMER_WIZARD_CONTENT_WIDE_CLASS,
  CUSTOMER_FORM_ACTION_ROW_END_CLASS,
} from "../shared/customerLayoutSpec";

const Email = () => {
  const [verify, setVerify] = useState(false);
  const [ShowCrossButton, setShowCrossButton] = useState(true);

  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className={`${CUSTOMER_WIZARD_CONTENT_WIDE_CLASS} space-y-5`}>
          <div className="space-y-1">
            <AdminDetailFieldLabel htmlFor="current-email">Email address</AdminDetailFieldLabel>
            <input
              id="current-email"
              type="email"
              placeholder="Email address"
              className={`${adminWizardInputClasses(false)} lg:bg-pastalblue`}
            />
          </div>
          <div className="space-y-1">
            <AdminDetailFieldLabel htmlFor="new-email">New email address</AdminDetailFieldLabel>
            <input
              id="new-email"
              type="email"
              placeholder="Enter new email address"
              className={`${adminWizardInputClasses(false)} lg:bg-pastalblue`}
            />
          </div>
          <div className={CUSTOMER_FORM_ACTION_ROW_END_CLASS}>
            <AdminHeaderAction type="button" onClick={() => setVerify(true)}>
              Verify
            </AdminHeaderAction>
          </div>
        </div>
      </form>
      {verify && (
        <Popup
          setTrigger={() => setVerify(false)}
          ShowCrossButton={ShowCrossButton}
          popupWidth="w-[350px] h-[450px] sm:w-[600px] sm:h-[500px] 2xl:w-[550px] 2xl:h-[600px]"
          crossPosition="flex justify-end w-[16px] absolute left-[310px] sm:left-[555px] 2xl:left-[505px] top-3"
        >
          <VerificationPopUp
            closePopup={() => setVerify(false)}
            firstMainHeading="Email verification"
            label="Varification code"
            placeholder="Input the code here."
            firstP="Check your inbox for a verification code and enter it below. Confirming your email helps safeguard your account and ensures reliable communication."
            secondMainHeading="Email verified"
            secondP="Success! Your email is verified, and you'll now receive important updates. Thank you for keeping your account secure."
            buttonText="Submit"
          />
        </Popup>
      )}
    </>
  );
};

export default Email;
